import { IOfferCard } from '../../../types';

export function getLeasePeriod({ category, bargainTerms: { leaseTermType } }: IOfferCard) {
  if (category && category.startsWith('daily')) {
    return 'посуточно';
  }

  if (leaseTermType === 'longTerm') {
    return 'от года';
  }

  if (leaseTermType === 'fewMonths') {
    return 'на несколько месяцев';
  }

  return undefined;
}
